import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useIncludePriceOnProductSuggestions = createExperimentHook(
  'suggest-show-product-prices',
  false,
  {
    showPrices: true,
  }
);

export const useNewResponseFormatForSuggestions = createExperimentHook(
  'new-format-for-suggestions',
  false,
  {
    useNewFormat: true,
  }
);

export const useAlternativeFacetNavigation = createExperimentHook(
  'alternative-facet-navigation',
  false,
  {
    useAlternativeFacetNavigation: true,
  }
);

export const useChangelogPositionExperiment = createExperimentHook(
  'changelog-position',
  true,
  { alternate: false }
);

export const useNewSearchPredictions = createExperimentHook(
  'new-search-predictions',
  false,
  { new: true }
);

export type DeliveryTimeExperimentType =
  | boolean
  | 'green button'
  | 'blue button';

export const useDeliveryTimeExperiment = createExperimentHook<
  DeliveryTimeExperimentType
>('delivery-time', false, {
  showWithGreenButton: 'green button',
  showWithBlueButton: 'blue button',
});

export const useHighlightOfferExperiment = createExperimentHook(
  'highlight-offer-only',
  false,
  {
    show: true,
  }
);

export const useNewProductCardForDealsExperiment = createExperimentHook(
  'new-product-card-for-deals',
  false,
  { new: true }
);

export const useMobileTopAd = createExperimentHook('mobile-top-ad', false, {
  showAd: true,
});

export const useNewSearchApi = createExperimentHook('new-search-api', false, {
  new: true,
});
